/**
 * Services Index
 * Central export point for all API services
 */

// Import services
import authService from './authService';
import customerService from './customerService';
import productService from './productService';
import supplierService from './supplierService';
import salesService from './salesService';
import creditNoteService from './creditNoteService';
import purchaseService from './purchaseService';
import mastersService from './mastersService';

// Export all services
export {
  authService,
  customerService,
  productService,
  supplierService,
  salesService,
  creditNoteService,
  purchaseService,
  mastersService
};

// Default export for convenience
export default {
  auth: authService,
  customers: customerService,
  products: productService,
  suppliers: supplierService,
  sales: salesService,
  creditNotes: creditNoteService,
  purchases: purchaseService,
  masters: mastersService
};
